import lrTxt from './_src/lrTxt.vue'
lrTxt.install = function(Vue) {
  Vue.component(lrTxt.name, lrTxt)
}
export default lrTxt